import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { ArrowLeftOutlined, QuestionCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { getQueryParams, callApi, gotoManagement } from 'utils';
import { observer } from 'react-ahax';
import PropTypes from 'prop-types';
import { SCOPECHANGE, HELPBUTTON } from 'action';
import './index.less';

/**
 * 解析当前的 PageParams
 * */
const PUBLICMODULES = ['file-center', 'bussiness-authorization', 'admin-management'];
const analyzePageParams = pageParams => {
	const pages = {};
	pageParams = decodeURIComponent(pageParams);

	const pagesArray = pageParams.split('&');
	pagesArray.forEach(item => {
		const params = {};
		const arr = item.split('=');
		if (arr[1]) {
			const paramsArray = arr[1].split('|');
			paramsArray.forEach(param => {
				const paramArr = param.split('^');
				params[paramArr[0]] = paramArr[1];
			});
			pages[arr[0]] = params;
		}
	});
	return pages;
};

/**
 * 设置新的 PageParams
 * */
const setPageParams = pages => {
	let params = '';
	for (const i in pages) {
		if (typeof pages[i] === 'object') {
			let subParams = '';
			for (const j in pages[i]) {
				subParams += `|${j}^${pages[i][j]}`;
			}
			subParams = subParams.substring(1);
			params += `&${i}=${subParams}`;
		}
	}
	params = params.substring(1);

	return encodeURIComponent(params);
};

/**
 * 设置url search
 * */
const setSearch = (pathSnippet, location) => {
	let search = '';
	const pageParams = getQueryParams().pageParams;
	if (pageParams) {
		const pages = analyzePageParams(pageParams);
		const query = pages[pathSnippet];
		if (query) {
			for (const i in query) {
				search += `${search ? '&' : '?'}${i}=${query[i]}`;
			}
			delete pages[pathSnippet];
		}

		const newPageParams = setPageParams(pages);
		if (newPageParams) search += `${search ? '&' : '?'}pageParams=${newPageParams}`;
	}
	const appId = getQueryParams().appId;
	if (appId && search.indexOf('appId=') === -1) {
		search += `${search ? '&' : '?'}appId=${appId}`;
	}

	return search;
};

@observer([SCOPECHANGE])
class LayoutBreadcrumb extends React.Component {
	state = {
		hasManagementBtns: false, // 是否拥有管理权限
		inModuleMainPage: false, // 是否在模块的主页面
		showDetailBreadcrumb: false, // 是否显示详细的面包屑，默认只显示最后一级
		collapseLinksWidth: 0, // 被收起的面包屑的宽度
	};

	onEventAction ({ payload }) {
		const { appId, moduleId, organizationId } = payload;
		this.checkModuleManage({
			ownerType: 'EhOrganizations',
			ownerId: organizationId,
			moduleId,
			organizationId,
			appId
		});
	}

	componentDidMount () {
		this.setState({
			inModuleMainPage: window.inModuleMainPage
		});
	}

	componentDidUpdate (prevProps, prevState, snapshot) {
		const { inModuleMainPage } = this.state;
		if (window.inModuleMainPage !== inModuleMainPage) {
			this.setState({
				inModuleMainPage: window.inModuleMainPage
			});
		}
	}

	checkModuleManage = data => {
		callApi({
			api: '/module/checkModuleManage',
			data,
			success: (response) => {
				const { location } = this.props;
				const dataType = location.pathname.split('/')[1];
				const specialModules = ['sensitive-word']; // 框架业务中特殊带有管理页面的模块
				const hasManagementBtns = !!response || specialModules.includes(dataType);
				this.setState({ hasManagementBtns });
				window.$$context.hasModuleManage = hasManagementBtns;
			}
		});
	};

	isPublicModule = () => {
		return true;
	};

	showDetailBreadcrumb = () => {
		const collapseLinksWidth = this.collapseLinks ? this.collapseLinks.offsetWidth : 0;
		this.setState({ showDetailBreadcrumb: true, collapseLinksWidth: collapseLinksWidth });
	};

	hideDetailBreadcrumb = () => {
		const collapseLinksWidth = this.collapseLinks ? this.collapseLinks.offsetWidth : 0;
		this.setState({ showDetailBreadcrumb: false, collapseLinksWidth: collapseLinksWidth });
	};

	goBack = () => {
		this.hideDetailBreadcrumb();
		this.props.history.goBack();
	}

	render () {
		const prefixCls = 'eh-layout-breadcrumb';
		let { location, routes, btns = [], name, style, helpBtn, hasHelpDocumentsBtn } = this.props;
		const { hasManagementBtns, inModuleMainPage, showDetailBreadcrumb, collapseLinksWidth } = this.state;
		// 将所有管理按钮隐藏
		btns = btns.filter(item => item.label !== '管理');
		// 当前路径 ["app-config","business-app-config"]
		const pathSnippets = location.pathname.split('/').filter(i => i);
		const extraBreadcrumbItems = [];
		let breadcrumbNumber = 0;
		// 公共模块显示公共模块的名字，不显示当前选中的模块名字，比如 从打卡考勤导出报表跳转至文件下载中心，跳转到文件下载中心后显示 文件下载中心 而不是 打卡考勤
		let isPublicModule = false;
		pathSnippets.forEach((_, index) => {
			if (index === 0 && PUBLICMODULES.includes(_)) {
				isPublicModule = true;
			}
			const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
			if (routes[url]) {
				breadcrumbNumber++;
			}
		});
		pathSnippets.forEach((_, index) => {
			const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
			if (routes[url]) {
				if (index === pathSnippets.length - 1) {
					extraBreadcrumbItems.push(
						<span className={`${prefixCls}-link`} key={url}>
							{pathSnippets.length === 1 && !isPublicModule ? name || routes[url] : routes[url]}
						</span>
					);
					return;
				}

				const search = setSearch(_, location);
				if (index === 0) {
					extraBreadcrumbItems.push(
						<span className={`${prefixCls}-link`} key={url}>
							{extraBreadcrumbItems.length + 1 === breadcrumbNumber ? (
								<span>{isPublicModule ? routes[url] : name || routes[url]}</span>
							) : (
								<Link to={`${url + search}`}>{isPublicModule ? routes[url] : name || routes[url]}</Link>
							)}
						</span>
					);
					return;
				}

				extraBreadcrumbItems.push(
					<span className={`${prefixCls}-link`} key={url}>
						{extraBreadcrumbItems.length + 1 === breadcrumbNumber ? (
							<span> {routes[url]}</span>
						) : (
							<Link to={`${url + search}`}>{routes[url]}</Link>
						)}
					</span>
				);
			}
		});
		// 将面包屑的最后一级移动到 lastBreadcrumbItem
		const lastBreadcrumbItem = extraBreadcrumbItems.splice(extraBreadcrumbItems.length - 1);
		return (
			<div
				className={prefixCls}
				style={style}
				onMouseLeave={showDetailBreadcrumb ? this.hideDetailBreadcrumb : undefined}
			>
				<div className={`${prefixCls}-content`}>
					{!!extraBreadcrumbItems.length && (
						<ArrowLeftOutlined
							onClick={this.goBack}
							onMouseEnter={!showDetailBreadcrumb ? this.showDetailBreadcrumb : undefined} />
					)}
					<div
						className={`${prefixCls}-links ${showDetailBreadcrumb ? '' : 'hidden'}`}
						style={{ width: (showDetailBreadcrumb && extraBreadcrumbItems.length) ? collapseLinksWidth : 0 }}
					>
						<div
							className={`${prefixCls}-links-content`}
							ref={ref => {
								this.collapseLinks = ref;
							}}
						>
							{extraBreadcrumbItems.map((item, index) => {
								return (
									<span className={`${prefixCls}-links-item`} key={index}>
										<span onClick={this.hideDetailBreadcrumb}>{item}</span>
										<span className={`${prefixCls}-separator`}>
											<RightOutlined />
										</span>
									</span>
								);
							})}
						</div>
					</div>
					<div className={`${prefixCls}-current`}>{lastBreadcrumbItem}</div>
				</div>
				<div className={`${prefixCls}-btns`}>
					{hasHelpDocumentsBtn && helpBtn ? <Button
						type='link'
						icon={<QuestionCircleOutlined />}
						onClick={() => {
							this.props.history.push(helpBtn.to);
							this.dispatch({
								type: HELPBUTTON,
								payload: null
							});
						}}
					>
							操作指引
					</Button>
						: null}
					{btns.map(({ label, to, component }, index) => {
						return component || (
							<Button
								key={index}
								onClick={() => {
									this.props.history.push(to);
								}}
							>
								{label}
							</Button>
						);
					})}

					{/* 在模块的主页面，且有管理按钮权限时，统一显示管理按钮（临时方案） */}
					{hasManagementBtns && inModuleMainPage && (
						<Button
							type="primary"
							onClick={() => gotoManagement()}
						>
							管理
						</Button>
					)}
				</div>
			</div>
		);
	}
}

LayoutBreadcrumb.propTypes = {
	btns: PropTypes.array,
	routes: PropTypes.object,
	style: PropTypes.object,
	helpBtn: PropTypes.object,
	hasHelpDocumentsBtn: PropTypes.bool,
};
export default withRouter(LayoutBreadcrumb);
